// extracted by mini-css-extract-plugin
module.exports = {"userForm":"styles_userForm__1e0Bd","inputs":"styles_inputs__1Jsqe","input":"styles_input__26Py9","buttons":"styles_buttons__GB1Nc","submitButton":"styles_submitButton__2kNar"};